import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import ManagementDesktop from "./ManagementDesktop";
import ManagementMobile from "./ManagementMobile";

function Management({ app, config, filter }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <ManagementMobile app={app} config={config} filter={filter} />
  ) : (
    <ManagementDesktop app={app} config={config} filter={filter} />
  );
}

Management.defaultProps = {
  app: null,
  config: {},
  filter: "",
};

Management.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  filter: PropTypes.string,
};

export default Management;
